import collectionDatasetActions from '@/collections/datasets/constants';
import withDraft from '@/utils/draftHelper';
import actions from '../collections/constants';
import { addDatasetListCollectionsState, removeDatasetListCollectionsState } from './state';

const addDatasetCollectionsSuccess = withDraft((draft, action) => {
  addDatasetListCollectionsState(draft, action);
});

const addCollectionDatasetsSuccess = withDraft((draft, { collection, items }) => {
  items.forEach(({ code }) => {
    addDatasetListCollectionsState(draft, { code, items: [collection] });
  });
});

const removeDatasetCollectionsSuccess = withDraft((draft, { code, collectionCode }) => {
  removeDatasetListCollectionsState(draft, { code, items: [{ code: collectionCode }] });
});

const removeCollectionDatasetsSuccess = withDraft((draft, { collection, items }) => {
  items.forEach(({ code }) => {
    removeDatasetListCollectionsState(draft, { code, items: [collection] });
  });
});

export default {
  [actions.ADD_DATASET_COLLECTIONS_SUCCESS]: addDatasetCollectionsSuccess,
  [actions.REMOVE_DATASET_COLLECTION_SUCCESS]: removeDatasetCollectionsSuccess,
  [collectionDatasetActions.ADD_COLLECTION_DATASETS_SUCCESS]: addCollectionDatasetsSuccess,
  [collectionDatasetActions.REMOVE_COLLECTION_DATASETS_SUCCESS]: removeCollectionDatasetsSuccess,
};
